import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-live",
  "use": "icon-live-usage",
  "viewBox": "0 0 1126 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1126 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-live\"><path d=\"M819.2 512v512h307.2V512H819.2zM409.6 0v1024h307.2V0H409.6zM0 307.2v716.8h307.2V307.2H0z\" p-id=\"13687\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol